import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import GoogleMap from './google'
import BaiduMap from './baidu'
import { classNames } from '@dt/fe-utils'
import './index.scss'

const { codeType, STOREID } = Config

// interface
interface IProps {
  className?: string;
  /** 用来设置不同map的id */
  type?: 'address' | 'decoration' | 'menu';
  mapType: 'baidu' | 'google';
  // 地图中心点
  center?: {
    lat: number;
    lng: number;
  };
  // 当前选中的目标
  activeMarker?: string;
  // 门店信息
  stores?: IViewStore[];
  onPointClick?(store: IViewStore): void;
  onSelectAddress?: (info: any) => void;
  onError?: (error: any) => void;
}
interface IState {
  filterStores: IViewStore[];
}
const Map: FC<IProps> = (props: IProps) => {
  const { className, mapType, type = 'address', center, activeMarker, stores = [], onPointClick, onSelectAddress, onError } = props

  const initialState: IState = {
    filterStores: []
  }
  const [filterStores, setFilterStores] = useState(initialState.filterStores)
  const handlePointClick = function (store: IViewStore) {
    onPointClick?.(store)
  }
  useEffect(() => {
    if (stores.length) {
      let filterStores = stores
      // 门店码、桌码只显示当前门店
      if (['store', 'table'].includes(codeType)) {
        filterStores = filterStores.filter(store => store.storeId === STOREID)
      }
      filterStores.length && setFilterStores(filterStores)
    }
  }, [stores])
  return (
    <div
      className={classNames('map-container', className)}
    >
      {
        mapType === 'baidu' ? (
          <BaiduMap
            id={`${type}-map-container`}
            center={center}
            activeMarker={activeMarker}
            stores={filterStores}
            onPointClick={(store) => handlePointClick(store)}
            onSelectAddress={(info: any) => {
              onSelectAddress({
                mapType: 'baidu',
                ...info
              })
            }}
            onError={onError}
          />
        ) : (
          <GoogleMap
            center={center}
            activeMarker={activeMarker}
            stores={filterStores}
            onPointClick={(store) => handlePointClick(store)}
            onSelectAddress={(info: any) => {
              onSelectAddress({
                mapType: 'google',
                ...info
              })
            }}
            onError={onError}
          />
        )
      }
    </div>
  )
}

export default observer(Map)
